import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {ServiceCatalogScheme, ServiceCatalogSchemeInput} from './service-catalog-scheme.model';

export const loadServiceCatalogSchemes = createAction(
  '[ServiceCatalogScheme/API] Load ServiceCatalogSchemes',
  props<{ serviceCatalogSchemes: ServiceCatalogScheme[] }>()
);

export const addServiceCatalogScheme = createAction(
  '[ServiceCatalogScheme/API] Add ServiceCatalogScheme',
  props<{ serviceCatalogScheme: ServiceCatalogScheme }>()
);

export const upsertServiceCatalogScheme = createAction(
  '[ServiceCatalogScheme/API] Upsert ServiceCatalogScheme',
  props<{ serviceCatalogScheme: ServiceCatalogScheme }>()
);

export const addServiceCatalogSchemes = createAction(
  '[ServiceCatalogScheme/API] Add ServiceCatalogSchemes',
  props<{ serviceCatalogSchemes: ServiceCatalogScheme[] }>()
);

export const upsertServiceCatalogSchemes = createAction(
  '[ServiceCatalogScheme/API] Upsert ServiceCatalogSchemes',
  props<{ serviceCatalogSchemes: ServiceCatalogScheme[] }>()
);

export const updateServiceCatalogScheme = createAction(
  '[ServiceCatalogScheme/API] Update ServiceCatalogScheme',
  props<{ serviceCatalogScheme: Update<ServiceCatalogScheme> }>()
);

export const updateServiceCatalogSchemes = createAction(
  '[ServiceCatalogScheme/API] Update ServiceCatalogSchemes',
  props<{ serviceCatalogSchemes: Update<ServiceCatalogScheme>[] }>()
);

export const deleteServiceCatalogScheme = createAction(
  '[ServiceCatalogScheme/API] Delete ServiceCatalogScheme',
  props<{ id: string }>()
);

export const deleteServiceCatalogSchemes = createAction(
  '[ServiceCatalogScheme/API] Delete ServiceCatalogSchemes',
  props<{ ids: string[] }>()
);

export const clearServiceCatalogSchemes = createAction(
  '[ServiceCatalogScheme/API] Clear ServiceCatalogSchemes'
);


// CUSTOM
export const createServiceCatalogSchemes = createAction(
  '[ServiceCatalogScheme/API] create ServiceCatalogSchemes',
  props<{ input: ServiceCatalogSchemeInput }>()
);


export const editServiceCatalogSchemes = createAction(
  '[ServiceCatalogScheme/API] edit ServiceCatalogSchemes',
  props<{ input: ServiceCatalogSchemeInput }>()
);


export const removeServiceCatalogScheme = createAction(
  '[ServiceCatalogScheme/API] remove ServiceCatalogSchemes',
  props<{ catalogUniqueId: string, id:string }>()
);


export const getServiceCatalogSchemes = createAction(
  '[ServiceCatalogScheme/API] get ServiceCatalogSchemes',
  props<{ billingUniqueId: string }>()
);


export const citizenGetInstitutionServiceCatalogSchemes = createAction(
  '[ServiceCatalogScheme/API] citizen get institution ServiceCatalogSchemes',
  props<{ billingUniqueId: string }>()
);
